var option_default = {
  "option": "-qT-n",
  "user_choice": "-hEYD",
  "check": "NjNcN",
  "image": "wQy78",
  "input": "Mj3Zt",
  "title": "axqHP",
  "centered": "_3pRkS",
  "with_result": "_4ig5P",
  "list": "GUQ7B",
  "with_image": "AKds3",
  "progress": "KD13V",
  "progress_value": "MbKKz",
  "label": "Mr10U",
  "cta": "Caw-n",
  "adornment_icon": "wtAxr",
  "remove": "fQ8q7",
  "removeButton": "W8z2D",
  "removeButtonIcon": "v9zbn",
  "overlay": "jAefo",
  "shown": "RtYZu",
  "dark": "S7M4Y",
  "spinner": "_-1FAE",
  "spin": "RAwnC"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
